<template>
  <div class="login-page" :style="backgroundStyle">
    <div class="form-area">
      <div class="login-card">
        <!-- Logo grande, más ancho que el form -->
        <img
          :src="isMobile ? '/ejecutivo/logo movil.png' : '/ejecutivo/logotipo.png'"
          alt="Movistar Empresas"
          class="logo-img"
        />
        <!-- Form angosto, centrado bajo el logo -->
        <div class="form-wrapper">
          <p class="login-title">Ingresa con los siguientes datos</p>
          <form @submit.prevent="login">
            <div class="field">
              <input v-model="form.idpdv" type="text" placeholder="IDPDV" required />
            </div>
            <div class="field">
              <input v-model="form.axc" type="text" placeholder="AXC/MRT" required />
            </div>
            <div class="field">
              <input v-model="form.email" type="email" placeholder="Email" required />
            </div>
            <div v-if="needsNombre" class="field">
              <input v-model="form.nombre" type="text" placeholder="Nombre completo" required />
            </div>
            <p v-if="error" class="error-msg">{{ error }}</p>
            <button type="submit" class="btn-enviar" :disabled="loading">
              {{ loading ? 'Ingresando...' : 'Enviar' }}
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginView',
  data() {
    return {
      form: { idpdv: '', axc: '', email: '', nombre: '' },
      needsNombre: false,
      cacData: null,
      error: '',
      loading: false,
      isMobile: window.innerWidth <= 768
    }
  },
  computed: {
    backgroundStyle() {
      const img = this.isMobile ? '/ejecutivo/fondo_actual_movil.jpg' : '/ejecutivo/fondo_actual_pc.jpg';
      return {
        backgroundImage: `url(${img})`,
        backgroundSize: 'cover',
        backgroundPosition: this.isMobile ? 'top center' : 'left center'
      }
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.isMobile = window.innerWidth <= 768;
    },
    async login() {
      this.error = '';
      this.loading = true;
      try {
        // Si ya se mostró el campo nombre, completar login con nombre manual
        if (this.needsNombre) {
          const data = { ...this.cacData, nombre: this.form.nombre };
          this.$store.commit('setEjecutivo', data);
          this.$router.push('/');
          return;
        }

        const res = await this.$api.post('ejecutivo/login', this.form);
        if (res.data.success) {
          if (res.data.needs_nombre) {
            // Email no encontrado: mostrar campo nombre para captura manual
            this.cacData = res.data.data;
            this.needsNombre = true;
          } else {
            this.$store.commit('setEjecutivo', res.data.data);
            this.$router.push('/');
          }
        }
      } catch (err) {
        if (err.response && err.response.data && err.response.data.message) {
          this.error = err.response.data.message;
        } else {
          this.error = 'Error de conexión, intenta de nuevo';
        }
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>

<style scoped>
.login-page {
  width: 100%;
  min-height: 100vh;
  display: flex;
  overflow-x: hidden;
}

/* ============================
   FORM AREA - right side, vertically centered
   ============================ */
.form-area {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 14vw 0 0;
}

/* Card ancho para que el logo quepa grande */
.login-card {
  width: clamp(380px, 36vw, 580px);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* ============================
   LOGO - mucho más grande que los campos
   ============================ */
.logo-img {
  width: 100%;
  height: auto;
  margin-bottom: clamp(30px, 3.5vw, 55px);
}

/* ============================
   FORM WRAPPER - más angosto que el logo, centrado
   ============================ */
.form-wrapper {
  width: 52%;
}

/* ============================
   TITLE
   ============================ */
.login-title {
  color: rgba(255, 255, 255, 0.75);
  font-size: clamp(14px, 1.4vw, 20px);
  text-align: center;
  margin-bottom: clamp(14px, 1.4vw, 24px);
  font-family: TelefonicaLight, sans-serif;
}

/* ============================
   FIELDS
   ============================ */
.field {
  margin-bottom: clamp(12px, 1.1vw, 18px);
}

.field input {
  width: 100%;
  padding: clamp(9px, 0.75vw, 13px) 0;
  border: none;
  border-radius: 30px;
  font-size: clamp(11px, 0.82vw, 13px);
  outline: none;
  background: rgba(255, 255, 255, 0.95);
  color: #333;
  font-family: TelefonicaRegular, sans-serif;
  transition: box-shadow 0.2s;
  text-align: center;
}

.field input::placeholder {
  color: #aaa;
  font-size: clamp(11px, 0.82vw, 13px);
  text-align: center;
}

.field input:focus {
  background: #fff;
  box-shadow: 0 0 0 2px rgba(100, 180, 255, 0.4);
}

/* ============================
   ERROR
   ============================ */
.error-msg {
  color: #ff6b6b;
  text-align: center;
  font-size: clamp(11px, 0.85vw, 13px);
  margin-bottom: clamp(6px, 0.5vw, 10px);
}

/* ============================
   BUTTON - más delgado y ancho que los campos
   ============================ */
.btn-enviar {
  width: 72%;
  margin-left: auto;
  margin-right: auto;
  display: block;
  padding: clamp(5px, 0.4vw, 8px);
  border: none;
  border-radius: 30px;
  background: #E535AB;
  color: #fff;
  font-size: clamp(11px, 0.82vw, 13px);
  cursor: pointer;
  transition: background 0.25s;
  margin-top: clamp(10px, 1vw, 16px);
  font-family: TelefonicaRegular, sans-serif;
}

.btn-enviar:hover {
  background: #c92d96;
}

.btn-enviar:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

/* ============================
   TABLET (769 - 1024)
   ============================ */
@media (min-width: 769px) and (max-width: 1024px) {
  .form-area {
    padding-right: 5vw;
  }
  .login-card {
    width: clamp(280px, 34vw, 380px);
  }
}

/* ============================
   MOBILE (<= 768)
   ============================ */
@media (max-width: 768px) {
  .login-page {
    flex-direction: column;
  }

  .form-area {
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    padding: 12px 40px 40px;
    min-height: 100vh;
  }

  .login-card {
    width: 100%;
    max-width: 280px;
    flex-direction: column;
    align-items: center;
  }

  .logo-img {
    max-width: 260px;
    margin-top: 0;
    margin-bottom: 38vh;
  }

  .form-wrapper {
    width: 100%;
  }

  .login-title {
    font-size: 14px;
    margin-bottom: 18px;
  }

  .field {
    margin-bottom: 12px;
  }

  .field input {
    padding: 12px 22px;
    font-size: 16px;
  }

  .field input::placeholder {
    font-size: 16px;
  }

  .btn-enviar {
    width: 60%;
    padding: 10px;
    font-size: 14px;
    margin-top: 8px;
  }
}
</style>
